import { Edit } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import Facture from '../../../Components/Docs/Facture';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import ChangeStatusPaymentFacture from '../../../Components/shared/ChangeStatusPaymentFacture';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import {statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue, sortDate, UpperCasePrenomNom } from '../../../Utils/utils';
import { getMargeBrute, getMargeNet, getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from '../../Expert/Mission/HeaderAllFacture';

const AllRegularisationAdmin = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();

    const { setBackdropOpen} = useUtilities();
    const [roleFacture,setRoleFacture]=useState('');

    const factureColumns4BackOffice = [
        {
            field: 'refFactureClient',
            title: i18n.t('Réf.Facture ou Avoir/Client'),
            render:  rowData => (
                <Button
                    variant='text'
                    onClick={()=> {
                        Promise.resolve().then(() => {
                            setRowSelected(rowData);
                            setRoleFacture('client');
                        }).then(() => setOpen(true));
                    }}
                >
                    {rowData?.refFactureClient}
                </Button>
            )
        },
        {
            field: 'refFactureExpert',
            title: i18n.t('Réf.Facture ou Avoir/Expert'),
            render:  rowData => (
                <Button
                    variant='text'
                    onClick={()=> {
                        Promise.resolve().then(() => {
                            setRowSelected(rowData);
                            setRoleFacture('expert');
                        }).then(() => setOpen(true));
                    }}
                >
                    {rowData?.refFactureExpert}
                </Button>
            )
        },
        {
            field: 'eye',
            title: i18n.t('Option'),
            render: rowData =>{
                return (
                    <IconButton
                        disabled={(rowData?.statutPaiementClient!='Payé' || rowData?.statutPaiementClient!='Payé')? false:true}
                        onClick={() => {
                            if (rowData?.isCraOrCraX=='craXId') {
                                navigate('/admin/RegularizationPC', {state: {rowData} });
                            }
                            else
                                navigate('/admin/NormalRegularization', {state: {rowData} });
                        }}
                    >
                        <Edit />
                    </IconButton>
                );
            },
        },
        {
            field: 'refIntClient',
            title: i18n.t('Réf.Int.Client'),
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData.dateEmission),
        },
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },
        {
            field: 'dateValidationCra',
            title: i18n.t('Date de validation CRA'),
        },
        {
            field: 'refClient',
            title: i18n.t('Réf. Client'),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),
        },
        {
            field: 'refExpert',
            title: i18n.t('Réf. Expert'),
        },
        {
            field: 'sourceExpert',
            title: i18n.t('Sce. Expert'),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        //{
        //    field: 'Statut',
        //    title: i18n.t('Statut Facture',
        //    render:  rowData =>
        //        searchLabelInEnumByValue(StatutFacture,(rowData?.Statut)),
        //},
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'statutPaiementExpert',
            title: i18n.t('Statut Paiement/Expert'),
            render:  rowData =>
                <ChangeStatusPaymentFacture
                    width={'100%'}
                    facture={rowData}
                    whoPays={'expert'}
                    getAllFacturesRefresh={()=>{getAllRegularisations(chargeRecrutementId);}}
                />,
        },
        {
            field: 'statutPaiementClient',
            title: i18n.t('Statut Paiement/Client'),
            render:  rowData =>
                <ChangeStatusPaymentFacture
                    width={'100%'}
                    facture={rowData}
                    whoPays={'client'}
                    getAllFacturesRefresh={()=>{getAllRegularisations(chargeRecrutementId);}}
                />,
        },
        {
            field: 'datePaiementClient',
            title: i18n.t('Date Paiement/Client'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementClient)
        },
        {
            field: 'datePaiementExpert',
            title: i18n.t('Date Paiement/Expert'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementExpert)
        },
        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjClientHt',
            title: i18n.t('TJ Client HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClientHt ),
        },
        {
            field: 'tjExpert',
            title: i18n.t('TJ Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjExpert),
        },
        {
            field: 'totalAstreinte',
            title: i18n.t('Total astreintes'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalAstreinte),
        },
        {
            field: 'totalAstreinteClient',
            title: i18n.t('Total astreintes Client'),
            render:  rowData =>{
                return addEuro4Decimal(rowData.totalAstreinteClient);
            }
        },
        {
            field: 'totalHnoClient',
            title: i18n.t('Total HNO Client'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHnoClient),
        },
        {
            field: 'totalHnoExpert',
            title: i18n.t('Total HNO Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHnoExpert),
        },
        {
            field: 'totalNotesFrais',
            title: i18n.t('Total notes de frais'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalNotesFrais),
        },
        {
            field: 'totalHTClient',
            title: i18n.t('Total HT/Client'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTClient),
        },
        {
            field: 'tvaClient',
            title: i18n.t('TVA Client'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tvaClient,'%'),
        },
        {
            field: 'totalTTCClient',
            title: i18n.t('Total TTC/Client'),
            render:  rowData =>
                addEuro4Decimal(getMontatantTTC(rowData.totalHTClient,rowData.tvaClient)),
        },
        {
            field: 'totalHTExpert',
            title: i18n.t('Total HT/Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTExpert),
        },
        {
            field: 'tvaExpert',
            title: i18n.t('TVA Expert'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tvaExpert,'%'),
        },
        {
            field: 'totalTTCExpert',
            title: i18n.t('Total TTC/Expert'),
            render:  rowData =>
                addEuro4Decimal(getMontatantTTC(rowData.totalHTExpert,rowData.tvaExpert)),
        },
        {
            field: 'margeBrut',
            title: i18n.t('Marge brute'),
            render: rowData =>{
                if(rowData?.isCraOrCraX=='craXId')
                    return 'PC';
                else
                    return addEuro4Decimal(getMargeBrute(rowData.totalHTClient,rowData.totalHTExpert));
            }
        },
        {
            field: 'margeNet',
            title: i18n.t('Marge nette'),
            render: rowData =>{
                if(rowData?.isCraOrCraX=='craXId')
                    return 'PC';
                else
                    addEuro4Decimal(getMargeNet(getMargeBrute(rowData.totalHTClient, rowData.totalHTExpert),rowData.totalHTClient));
            }
        },
        {
            field: 'respComptabilite',
            title: i18n.t('Resp.Comptabilité'),

        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),

        },
        {
            field: 'respAchat',
            title: i18n.t('Resp.Achat'),

        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),

        },
    ];

    const axiosPrivate = useAxiosPrivate();
    const [factureRows, setFactureRows] = useState([]);
    const [rowselected, setRowSelected] = useState();
    const [chargeRecrutementId,setChargeRecrutementId]=useState('');
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [filtreFactureExpertNonPaye, setFiltreFactureExpertNonPaye] = useState(searchParams.get('filtreFactureExpertNonPaye') === 'true');
    const [filtreFactureClientNonPaye, setFiltreFactureClientNonPaye] = useState(searchParams.get('filtreFactureClientNonPaye') === 'true');

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrefactureexpertnonpaye') && !url.toLowerCase().includes('filtrefactureclientnonpaye')){
            setFiltreFactureExpertNonPaye(false);
            setFiltreFactureClientNonPaye(false);
        }
    }, [url]);

    useEffect(() => {
        getMyInfos();
    }, [filtreFactureClientNonPaye,filtreFactureExpertNonPaye]);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        getMyInfos();
    }, [chargeRecrutementId]);

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get('admin/getMyInfos');
            if((response.data?.backOffice?.roles?.chargeRecrutement==1)){
                setChargeRecrutementId(response.data?.backOffice?._id);
                await getAllRegularisations(response.data?.backOffice?._id);
            }
            else{
                setChargeRecrutementId('');
                await getAllRegularisations('');
            }

        } catch (error) {
            console.log(error);
        }
    };

    const mapRegularisation = (regularisation) => {
        const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
        return {
            isCraOrCraX: isCraOrCraX,
            'id': regularisation?._id,
            //'refFactureClient': regularisation?.nbrUnite ? regularisation?.regularisationId : regularisation?.regularisationXId,
            'refFactureClient':regularisation?.refFacture,
            'refFactureExpert':regularisation?.refFacture+'E',
            //'refFactureExpert': regularisation?.nbrUnite ? regularisation?.regularisationId + 'E' : regularisation?.regularisationXId + 'E',
            'refCra': regularisation?.[isCraOrCraX]?.[isCraOrCraX],
            'refClient': regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.esnId,
            'nomClient': regularisation?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom ?? regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom,
            'refExpert': regularisation?.[isCraOrCraX]?.missionId?.expertId?.expertId,
            'nomExpert': UpperCasePrenomNom(regularisation?.[isCraOrCraX]?.missionId?.expertId?.persoData) ?? regularisation?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.profileEntreprise?.nom,
            'sourceExpert':regularisation?.[isCraOrCraX]?.missionId?.esnExpertOwnerId ? regularisation?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.profileEntreprise?.nom :'Freelance',
            'intituleMission': regularisation?.[isCraOrCraX]?.missionId?.titre,
            'dateValidationCra': Date(regularisation?.[isCraOrCraX]?.DateVC) > Date(regularisation?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVE),
            'dateEmission': formatDateJJMMYYYY(regularisation?.dateEmission),
            'Date':regularisation?.dateEmission, // champ spécifie le tri
            'refIntClient':regularisation?.refIntClient,
            //'Statut': regularisation?.nbrUnite ? regularisation?.statutRegularisation : regularisation?.statutRegularisationX,
            //'periode':regularisation?.[isCraOrCraX]?.month,
            'periode':
                dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY'),

            //'dateEcheance':formatDateJJMMYYYY(moment(regularisation?.dateEmission).add('days',regularisation?.delaiPaiement)),
            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                (regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',regularisation?.delaiPaiement)),
            'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,regularisation?.statutPaimentExpert)),
            'statutPaiementClient':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,regularisation?.statutPaimentClient)),
            'datePaiementClient':regularisation?.datePaimentClient,
            'datePaiementExpert':regularisation?.datePaimentExpert,
            'nbJour':regularisation?.nbrUnite,//reg normal
            'tjClientHt':regularisation?.[isCraOrCraX]?.tjClient,
            'tjExpert':regularisation?.[isCraOrCraX]?.tj,
            'tvaExpert':regularisation?.tva ?? regularisation?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.donneeFacturation?.tauxTva ?? regularisation?.[isCraOrCraX]?.missionId?.expertId?.entreprise?.tauxTva,
            'tvaClient':regularisation?.tvaClient ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.donneeFacturation?.tauxTva ?? regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.donneeFacturation?.tauxTva,

            'hnos':regularisation?.hnos,
            'astreintes':regularisation?.astreintes,
            'notesFrais':regularisation?.notesFrais,
            'totalAstreinte':regularisation?.totalAstreintes,
            'totalAstreinteClient':regularisation?.totalAstreintesClient ? regularisation?.totalAstreintesClient : regularisation?.totalAstreintes,
            'totalHnoClient':regularisation?.totalHnosClient,
            'totalHnoExpert': regularisation?.totalHnos,
            'totalNotesFrais':regularisation?.totalNotesFrais,
            // ! I think that this is the same calculation repeated ,,, but why It gives negative value for avoir in case of nbrDays exists inside cra, bcs there is no way to be nagative => car ces CRA wasn't treated by expert .. so there was no nbrDays, but if the expert changed the value of one day => we will have always positive values (this is bcs a copy/paste from AllFacture table ..)
            'totalHTExpert':regularisation?.montantTotal,
            'totalHTClient':regularisation?.montantTotalClient,
            // 'totalHTExpert':regularisation?.[isCraOrCraX]?.nbrDays ?(regularisation?.nbrUnite * regularisation?.[isCraOrCraX]?.tj): regularisation?.montantTotal,
            // 'totalHTClient':regularisation?.[isCraOrCraX]?.nbrDays ?(regularisation?.nbrUnite * regularisation?.[isCraOrCraX]?.tjClient): regularisation?.montantTotalClient,

            'respComptabilite':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableComptabiliteId?.persoData),
            'respOperationnel':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData),
            'respAchat':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableAchatId?.persoData),
            'chargeRecrutement':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
            // 'totalTva':
            ...regularisation
        };

    };

    //=============================================================================

    const getAllRegularisations = async (chargeRecrutementId) => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/facture/getAllRegularisations/', {
                // signal: controller.signal
            });
            console.log('RESPONSE', response);
            //?  if is mounted==true do next [setUsers..]
            // setFactures2(response.data.data)
            let listRegularisation = await response.data;
            let Array1=[];

            if(filtreFactureExpertNonPaye){
                Array1 = listRegularisation.reduce((acc, regularisation) => {
                    const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                    if(chargeRecrutementId && chargeRecrutementId==regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        if((regularisation?.statutPaimentExpert=='nonPaye'))
                            acc.push(mapRegularisation(regularisation));
                    if(chargeRecrutementId==''){
                        if((regularisation?.statutPaimentExpert=='nonPaye'))
                            acc.push(mapRegularisation(regularisation));
                    }

                    return acc;
                }, []);
            }
            else if(filtreFactureClientNonPaye){
                Array1 = listRegularisation.reduce((acc, regularisation) => {
                    const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                    if(chargeRecrutementId && chargeRecrutementId==regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        if((regularisation?.statutPaimentClient=='nonPaye'))
                            acc.push(mapRegularisation(regularisation));
                    if(chargeRecrutementId==''){
                        if((regularisation?.statutPaimentClient=='nonPaye'))
                            acc.push(mapRegularisation(regularisation));
                    }

                    return acc;
                }, []);
            }
            else{
                Array1 = listRegularisation.reduce((acc, regularisation) => {
                    const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                    if(chargeRecrutementId && chargeRecrutementId==regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?._id)
                        acc.push(mapRegularisation(regularisation));
                    if(chargeRecrutementId==''){
                        acc.push(mapRegularisation(regularisation));
                    }

                    return acc;
                }, []);
            }
            setFactureRows(sortDate(Array1));
            //setListFacture(arr);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };
    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('CRA & Factures')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Facturation')}</span>
            </div>
            <div className='HomeFrame'>
                <div style={{display:'flex',flexDirection:'row',alignSelf:'stretch',justifyContent:'space-between'}}>
                    <h4 className='titlesociete'>
                        {i18n.t('Factures')}
                    </h4>
                    <Button
                        style={{...buttonStylesGreen(false)}}
                        onClick={()=>{
                            Swal.fire({
                                title: i18n.t('Souhaitez vous faire une régularisation pour une:'),
                                html: '<input type="radio" id="option2" name="options" value="option2">' +
                                `<label for="option2"> &nbsp; ${i18n.t('Prestation normale')}</label>`+
                                ' &nbsp;&nbsp;' +
                                '<input type="radio" id="option1" name="options" value="option1">' +
                                `<label for="option1">&nbsp;${i18n.t('Prestation complémentaire')}</label>`,
                                showCancelButton:true,
                                confirmButtonColor: '#5CC889',
                                cancelButtonColor: '#88898f',
                                confirmButtonText: 'Valider',
                                cancelButtonText:'Annuler',
                                customClass: {
                                    cancelButton: 'my-cancel-button-class'
                                },
                                //confirmButtonText: 'Prestation complémentaire',
                                //cancelButtonText: 'Prestation normale',
                                showCloseButton: true
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const selectedOption = document.querySelector('input[name="options"]:checked').value;
                                    if (selectedOption=='option1') {
                                        navigate('/admin/RegularizationPC');
                                    }
                                    if(selectedOption=='option2'){
                                        navigate('/admin/NormalRegularization');
                                    }
                                }
                            });
                        } }
                    >
                        {i18n.t('Faire une régularisation')}
                    </Button>
                </div>
                <HeaderAllFacture />
                <MaterialTableComponent
                    title="Factures"
                    data={factureRows}
                    columns={factureColumns4BackOffice}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                    // onRowClick={(event, rowData) => {
                    //     console.log(event);
                    //     setRowSelected(rowData);
                    //     console.log(rowselected);
                    //     console.log(open);
                    //     setOpen(true);
                    // }}
                />
            </div>
            {open &&
            <Facture
                handleClose={handleClose}
                facture={rowselected}
                open={open}
                role={roleFacture}
                regularisation={'true'}
            />}
        </>
    );
};

export default AllRegularisationAdmin;
